import { defineStore } from 'pinia'
import { useReportStore } from './report'
import type { ILeftRightItem, ILeftRightOption } from '~/constants/types'
import { COPY, STORE } from '~/constants/strings'
import {
  availableSubPlansBottomText,
  includedSubPlanBottomText,
} from '~/helpers/aap'
import { api } from '~/services'
import { transformSubPlanResponseToILeftRightOption } from '~/utils/transforms'

interface RootState {
  items: ILeftRightItem[]
  // this is to keep track of SAVED selected sub plans
  savedSelectedSubPlans: ILeftRightOption[]
  isLoading: boolean
}

export const useAAPSubPlansStore = defineStore(STORE.SUBPLANS, {
  state: (): RootState => ({
    items: [
      {
        label: COPY.AVAILABLE_SUB_PLANS,
        bottomText: (o) => availableSubPlansBottomText(o),
        options: [],
      },
      {
        label: COPY.INCLUDED_SUB_PLANS,
        bottomText: (o) => includedSubPlanBottomText(o),
        options: [],
      },
    ],
    savedSelectedSubPlans: [],
    isLoading: false,
  }),
  actions: {
    async extractSubPlans() {
      const aapReportsStore = useReportStore()
      try {
        const subPlans = await api.plans.apiPlansSubplansMasterPlanIDGet(
          aapReportsStore.selectedPlan?.planID as string
        )

        const planOptions = transformSubPlanResponseToILeftRightOption(
          subPlans.data
        )
        const selectedPlans = planOptions.filter((it) => it.checked)
        const notSelectedPlans = planOptions.filter((it) => !it.checked)

        this.savedSelectedSubPlans = selectedPlans
        this.items[0].options = notSelectedPlans
        this.items[1].options = selectedPlans
      } catch (error) {
        console.error('error', error)
        aapReportsStore.error = true
      }
    },
    async saveSubPlans(data: ILeftRightOption[]) {
      const reportStore = useReportStore()
      this.isLoading = true
      try {
        await api.aapReports.apiAAPReportsSubplansMasterPlanIDPost(
          reportStore.selectedPlan?.planID as string,
          data.map((d: any) => d?.value)
        )
        this.savedSelectedSubPlans = data
        await this.extractSubPlans()
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
  },
})
